import Splide from '@splidejs/splide';

const slider = document.querySelector('.procedures-slider');

if( slider ) {
    var splide = new Splide( slider , {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: false,
        pagination: true,
        focus: 'center',
        start: 1,
        perPage: 4,
        perMove: 1,
        gap: 16,
        breakpoints: {
            1180: {
                perPage: 2,
                gap: '10%',
                padding: '10%',
            },
            768: {
                perPage: 1,
                gap: '10%',
                padding: '10%',
            },
        }
    });
    splide.mount();
}